export {AngularMaterialModule} from './lib/material.module';
